import operatorMap from "./modFieldOperatorMap.js";

const baseProperties = [
    "_name",
    "_key",
    "_description"
];
const commonProperties = [
    "_required",
    "_width",
    "_span",
    "_wrap",
    "_br",
    "_line",
    "_clearable"
];
const seniorProperties = [
    "_group",
    "_enterType",
    "_calculate",
    "_copyRef, _copyScreen, _copyField, _copyShowFields",
    "_displayType",
    "_rely"
];
const hideProperties = [
    "_type"
];
const unitWidth = 140;

// 备注解释
export const propertyComment = {
    canSearch: "搜索",
    canDefaultSearch: "默认搜索",
    canUpdate: "编辑",
    canBatchUpdate: "批量编辑",
    // canExport: "导出",
    canBatchExport: "批量导出",
    // canImport: "导入",
    canBatchImport: "批量导入",
    subLoop: "循环使用"
};

// 工作表字段-层级映射
export default function () {
    /**
    * operators 代表每种字段的可筛选的条件
    * searchProps 代表每种字段在筛选组件中传的参数
     */
    return {
        base: {
            name: "基础字段",
            type: "base",
            map: {
                text: {
                    name: "单行文本",
                    type: "text",
                    description: "纯文本格式，单行文本",
                    icon: "bico-text",
                    unitWidth,
                    canSearch: true,
                    canDefaultSearch: true,
                    canUpdate: true,
                    canBatchUpdate: true,
                    // canExport: true,
                    canBatchExport: true,
                    // canImport: true,
                    canBatchImport: true,
                    subLoop: true,
                    operators: operatorMap["text"],
                    searchProps: {
                        _type: "textMultiple",
                        _search: true
                    },
                    dataType: "string",
                    group: "base",
                    formMap: {
                        self: [
                            ...baseProperties,
                            ...commonProperties
                        ],
                        common: [
                            "_textType",
                            "_default"
                        ],
                        senior: [
                            ...seniorProperties
                        ],
                        hide: [
                            ...hideProperties
                        ]
                    }
                },
                textarea: {
                    name: "段落文本",
                    type: "textarea",
                    description: "纯文本格式、多行文本",
                    icon: "bico-ParagraphText",
                    unitWidth,
                    canSearch: true,
                    canDefaultSearch: true,
                    canUpdate: true,
                    canBatchUpdate: true,
                    // canExport: true,
                    canBatchExport: true,
                    // canImport: true,
                    canBatchImport: true,
                    subLoop: true,
                    operators: operatorMap["text"],
                    searchProps: {
                        _type: "textMultiple",
                        _search: true
                    },
                    dataType: "string",
                    group: "base",
                    formMap: {
                        self: [
                            ...baseProperties,
                            "_required",
                            "_width",
                            "_clearable"
                        ],
                        common: [
                            "_default"
                        ],
                        senior: [
                            ...seniorProperties
                        ],
                        hide: [
                            ...hideProperties,
                            "_span",
                            "_wrap",
                            "_br",
                            "_line"
                        ]
                    }
                },
                idcard: {
                    name: "身份证号",
                    type: "idcard",
                    description: "输入身份证号，并验证格式",
                    icon: "bico-id",
                    unitWidth: 180,
                    canSearch: true,
                    canDefaultSearch: true,
                    canUpdate: true,
                    canBatchUpdate: true,
                    // canExport: true,
                    canBatchExport: true,
                    // canImport: true,
                    canBatchImport: true,
                    subLoop: true,
                    operators: operatorMap["text"],
                    searchProps: {
                        _type: "textMultiple",
                        _search: true
                    },
                    dataType: "string",
                    group: "base",
                    formMap: {
                        self: [
                            ...baseProperties,
                            ...commonProperties
                        ],
                        common: [
                            "_default"
                        ],
                        senior: [
                            ...seniorProperties
                        ],
                        hide: [
                            ...hideProperties
                        ]
                    }
                },
                email: {
                    name: "电子邮件",
                    type: "email",
                    description: "输入邮箱，并验证格式",
                    icon: "bico-email",
                    unitWidth,
                    canSearch: true,
                    canDefaultSearch: true,
                    canUpdate: true,
                    canBatchUpdate: true,
                    // canExport: true,
                    canBatchExport: true,
                    // canImport: true,
                    canBatchImport: true,
                    subLoop: true,
                    operators: operatorMap["text"],
                    searchProps: {
                        _type: "textMultiple",
                        _search: true
                    },
                    dataType: "string",
                    group: "base",
                    formMap: {
                        self: [
                            ...baseProperties,
                            ...commonProperties
                        ],
                        common: [
                            "_default"
                        ],
                        senior: [
                            ...seniorProperties
                        ],
                        hide: [
                            ...hideProperties
                        ]
                    }
                },
                phone: {
                    name: "电话号码",
                    type: "phone",
                    subType: "_phoneType",
                    description: "可设为手机 或 座机，并验证格式",
                    icon: "bico-phone",
                    unitWidth,
                    canSearch: true,
                    canDefaultSearch: true,
                    canUpdate: true,
                    canBatchUpdate: true,
                    // canExport: true,
                    canBatchExport: true,
                    // canImport: true,
                    canBatchImport: true,
                    subLoop: true,
                    operators: operatorMap["text"],
                    searchProps: {
                        _type: "textMultiple",
                        _search: true
                    },
                    dataType: "string",
                    group: "base",
                    formMap: {
                        self: [
                            ...baseProperties,
                            ...commonProperties
                        ],
                        common: [
                            "_phoneType",
                            "_default"
                        ],
                        senior: [
                            ...seniorProperties
                        ],
                        hide: [
                            ...hideProperties
                        ]
                    }
                },
                serialNumber: {
                    name: "编号",
                    type: "serialNumber",
                    description: "随机编号",
                    icon: "bico-number",
                    unitWidth,
                    canSearch: false,
                    canDefaultSearch: false,
                    canUpdate: false,
                    canBatchUpdate: false,
                    // canExport: true,
                    canBatchExport: true,
                    // canImport: true,
                    canBatchImport: true,
                    subLoop: false,
                    // operators: operatorMap["text"],
                    // searchProps: {},
                    dataType: "string",
                    group: "base",
                    formMap: {
                        self: [
                            ...baseProperties,
                            ...commonProperties
                        ],
                        common: [

                        ],
                        senior: [
                            "_group"
                        ],
                        hide: [
                            ...hideProperties
                        ]
                    }
                },
                number: {
                    name: "数值输入",
                    type: "number",
                    description: "数值格式，可设置最小值、最大值",
                    icon: "bico-number",
                    unitWidth: 130,
                    canSearch: true,
                    canDefaultSearch: true,
                    canUpdate: true,
                    canBatchUpdate: true,
                    // canExport: true,
                    canBatchExport: true,
                    // canImport: true,
                    canBatchImport: true,
                    subLoop: true,
                    operators: operatorMap["range"],
                    searchProps: {
                        _type: "numberange"
                    },
                    dataType: "number",
                    group: "base",
                    formMap: {
                        self: [
                            ...baseProperties,
                            ...commonProperties
                        ],
                        common: [
                            "_min",
                            "_max",
                            "_round",
                            "_digit",
                            "_numberFormat",
                            "_unit",
                            "_separator",
                            "_showProgress",
                            "_default"
                        ],
                        senior: [
                            ...seniorProperties
                        ],
                        hide: [
                            ...hideProperties
                        ]
                    }
                },
                date: {
                    name: "日期",
                    type: "date",
                    description: "输入时间，可选择日期和日期范围两种",
                    icon: "bico-rate",
                    unitWidth,
                    canSearch: true,
                    canDefaultSearch: true,
                    canUpdate: true,
                    canBatchUpdate: true,
                    // canExport: true,
                    canBatchExport: true,
                    // canImport: true,
                    canBatchImport: true,
                    subLoop: true,
                    operators: operatorMap["range"],
                    searchProps: {
                        _type: "daterange"
                    },
                    dataType: "string",
                    group: "base",
                    formMap: {
                        self: [
                            ...baseProperties,
                            ...commonProperties
                        ],
                        common: [
                            "_dateType",
                            "_autoGetTime",
                            "_default"
                        ],
                        senior: [
                            ...seniorProperties
                        ],
                        hide: [
                            ...hideProperties
                        ]
                    }
                },
                switch: {
                    name: "开关",
                    type: "switch",
                    description: "开关，一般选择是否",
                    icon: "bico-on-off",
                    unitWidth: 80,
                    canSearch: true,
                    canDefaultSearch: true,
                    canUpdate: true,
                    canBatchUpdate: true,
                    // canExport: true,
                    canBatchExport: true,
                    // canImport: true,
                    canBatchImport: true,
                    subLoop: true,
                    operators: operatorMap["single"],
                    searchProps: {
                        _type: "checkbox",
                        _optionKind: "flat"
                    },
                    dataType: "boolean",
                    group: "base",
                    formMap: {
                        self: [
                            ...baseProperties,
                            ...commonProperties
                        ],
                        common: [
                            "_openText",
                            "_closeText",
                            "_default"
                        ],
                        senior: [
                            ...seniorProperties
                        ],
                        hide: [
                            ...hideProperties
                        ]
                    }
                },
                select: {
                    name: "单选",
                    type: "select",
                    description: "从预设的下拉菜单中选择一项，可设为将选项平铺",
                    icon: "bico-Radio",
                    unitWidth,
                    canSearch: true,
                    canDefaultSearch: true,
                    canUpdate: true,
                    canBatchUpdate: true,
                    // canExport: true,
                    canBatchExport: true,
                    // canImport: true,
                    canBatchImport: true,
                    subLoop: true,
                    operators: operatorMap["single"],
                    searchProps: {
                        _type: "checkbox",
                        _optionKind: "flat"
                    },
                    dataType: "string",
                    group: "base",
                    formMap: {
                        self: [
                            ...baseProperties,
                            ...commonProperties
                        ],
                        common: [
                            "_optionKind",
                            "_resourceKey",
                            "_useColor",
                            "_default"
                        ],
                        senior: [
                            ...seniorProperties
                        ],
                        hide: [
                            ...hideProperties,
                            "_data"
                        ]
                    }
                },
                checkbox: {
                    name: "多项选择",
                    type: "checkbox",
                    description: "多选设置框",
                    icon: "bico-checkbox",
                    unitWidth,
                    canSearch: true,
                    canDefaultSearch: true,
                    canUpdate: true,
                    canBatchUpdate: true,
                    // canExport: true,
                    canBatchExport: true,
                    // canImport: true,
                    canBatchImport: true,
                    subLoop: true,
                    operators: operatorMap["multiple"],
                    searchProps: {
                        _type: "checkbox",
                        _optionKind: "flat"
                    },
                    dataType: "array",
                    group: "base",
                    formMap: {
                        self: [
                            ...baseProperties,
                            ...commonProperties
                        ],
                        common: [
                            "_optionKind",
                            "_resourceKey",
                            "_useColor",
                            "_default"
                        ],
                        senior: [
                            ...seniorProperties
                        ],
                        hide: [
                            ...hideProperties,
                            "_data"
                        ]
                    }
                },
                file: {
                    name: "上传",
                    type: "file",
                    description: "上传图片和其他文件类型",
                    icon: "bico-upload",
                    unitWidth: 180,
                    canSearch: false,
                    canDefaultSearch: false,
                    canUpdate: true,
                    canBatchUpdate: false,
                    // canExport: false,
                    canBatchExport: false,
                    // canImport: false,
                    canBatchImport: false,
                    subLoop: true,
                    // operators: operatorMap["has"],
                    // searchProps: {
                    //     _type: "checkbox",
                    //     _optionKind: "flat"
                    // },
                    dataType: "array",
                    group: "base",
                    formMap: {
                        self: [
                            ...baseProperties,
                            ...commonProperties
                        ],
                        common: [
                            "_fileType",
                            "_autoArchive",
                            "_archiveKey"
                        ],
                        senior: [
                            ...seniorProperties
                        ],
                        hide: [
                            ...hideProperties
                        ]
                    }
                },
                region: {
                    name: "地区",
                    type: "region",
                    description: "选择地区",
                    icon: "bico-area",
                    unitWidth: 180,
                    canSearch: true,
                    canDefaultSearch: true,
                    canUpdate: true,
                    canBatchUpdate: true,
                    // canExport: true,
                    canBatchExport: true,
                    // canImport: true,
                    canBatchImport: true,
                    subLoop: true,
                    operators: operatorMap["cascader"],
                    searchProps: {
                        _type: "cascaderMultiple",
                        _subType: "region",
                        _changeOnSelect: true
                    },
                    dataType: "array",
                    group: "base",
                    formMap: {
                        self: [
                            ...baseProperties,
                            ...commonProperties
                        ],
                        common: [
                            "_changeOnSelect",
                            "_cascaderLevel",
                            "_default"
                        ],
                        senior: [
                            ...seniorProperties
                        ],
                        hide: [
                            ...hideProperties,
                            "_data"
                        ]
                    }
                },
                cascader: {
                    name: "级联",
                    type: "cascader",
                    description: "级联的描述",
                    icon: "bico-cascade",
                    unitWidth: 180,
                    canSearch: true,
                    canDefaultSearch: true,
                    canUpdate: true,
                    canBatchUpdate: true,
                    // canExport: true,
                    canBatchExport: true,
                    // canImport: true,
                    canBatchImport: true,
                    subLoop: true,
                    operators: operatorMap["cascader"],
                    searchProps: {
                        _type: "cascaderMultiple",
                        _changeOnSelect: true
                    },
                    dataType: "array",
                    group: "base",
                    formMap: {
                        self: [
                            ...baseProperties,
                            ...commonProperties
                        ],
                        common: [
                            "_resourceKey",
                            "_changeOnSelect",
                            "_cascaderLevel",
                            "_default"
                        ],
                        senior: [
                            ...seniorProperties
                        ],
                        hide: [
                            ...hideProperties,
                            "_data"
                        ]
                    }
                },
                coordinates: {
                    name: "地理坐标",
                    type: "coordinates",
                    description: "选择地理坐标",
                    icon: "bico-position",
                    unitWidth: 180,
                    canSearch: false,
                    canDefaultSearch: false,
                    canUpdate: true,
                    canBatchUpdate: true,
                    // canExport: true,
                    canBatchExport: true,
                    // canImport: false,
                    canBatchImport: false,
                    subLoop: false,
                    // operators: operatorMap["multiple"],
                    // searchProps: {
                    //     _type: "cascaderMultiple",
                    //     _subType: "coordinates",
                    //     _changeOnSelect: true
                    // },
                    dataType: "array",
                    group: "base",
                    formMap: {
                        self: [
                            ...baseProperties,
                            ...commonProperties
                        ],
                        common: [
                            "_showType",
                            "_autoLocation",
                            "_default"
                        ],
                        senior: [
                            ...seniorProperties
                        ],
                        hide: [
                            ...hideProperties,
                            "_data"
                        ]
                    }
                },
                editor: {
                    name: "富文本",
                    type: "editor",
                    description: "富文本",
                    icon: "bico-Richtext",
                    unitWidth,
                    canSearch: false,
                    canDefaultSearch: false,
                    canUpdate: true,
                    canBatchUpdate: false,
                    // canExport: false,
                    canBatchExport: false,
                    // canImport: false,
                    canBatchImport: false,
                    subLoop: false,
                    // operators: operatorMap["text"],
                    // searchProps: {
                    //     _type: "textMultiple"
                    // },
                    dataType: "string",
                    group: "base",
                    formMap: {
                        self: [
                            ...baseProperties,
                            "_required",
                            "_width"
                        ],
                        common: [
                            "_default"
                        ],
                        senior: [
                            ...seniorProperties
                        ],
                        hide: [
                            ...hideProperties,
                            "_span",
                            "_wrap",
                            "_br",
                            "_line",
                            "_clearable"
                        ]
                    }
                },
                tag: {
                    name: "分割线", // 改成分割线，原来页签
                    type: "tag",
                    description: "页签有分组的功能",
                    icon: "bico-tab",
                    unitWidth,
                    canSearch: false,
                    canDefaultSearch: false,
                    canUpdate: false,
                    canBatchUpdate: false,
                    // canExport: false,
                    canBatchExport: false,
                    // canImport: false,
                    canBatchImport: false,
                    subLoop: false,
                    // operators: operatorMap["text"],
                    // searchProps: {},
                    dataType: "undefined",
                    group: "base",
                    formMap: {
                        self: [
                            ...baseProperties
                        ],
                        common: [
                            "_tagKind",
                            "_tagIcon"
                        ],
                        senior: [
                            ...seniorProperties
                        ],
                        hide: [
                            ...hideProperties,
                            "_span",
                            "_wrap",
                            "_br",
                            "_line",
                            "_noLabel",
                            "_clearable"
                        ]
                    }
                }
            }
        },

        senior: {
            name: "高级字段",
            type: "senior",
            map: {
                users: {
                    name: "选择成员",
                    type: "users",
                    description: "选择成员的描述",
                    icon: "bico-member",
                    unitWidth,
                    canSearch: true,
                    canDefaultSearch: true,
                    canUpdate: true,
                    canBatchUpdate: true,
                    // canExport: true,
                    canBatchExport: true,
                    // canImport: false,
                    canBatchImport: false,
                    subLoop: true,
                    operators: operatorMap["multiple"],
                    searchProps: {
                        _type: "users",
                        _multiple: true,
                        _highSearch: true
                    },
                    dataType: "array",
                    group: "senior",
                    formMap: {
                        self: [
                            ...baseProperties,
                            ...commonProperties
                        ],
                        common: [
                            "_multiple",
                            "_default"
                        ],
                        senior: [
                            ...seniorProperties
                        ],
                        hide: [
                            ...hideProperties
                        ]
                    }
                },
                departments: {
                    name: "选择部门",
                    type: "departments",
                    description: "选择部门的描述",
                    icon: "bico-department",
                    unitWidth,
                    canSearch: true,
                    canDefaultSearch: true,
                    canUpdate: true,
                    canBatchUpdate: true,
                    // canExport: true,
                    canBatchExport: true,
                    // canImport: true,
                    canBatchImport: true,
                    subLoop: true,
                    operators: operatorMap["multiple"],
                    searchProps: {
                        _type: "departments",
                        _multiple: true,
                        _highSearch: true
                    },
                    dataType: "array",
                    group: "senior",
                    formMap: {
                        self: [
                            ...baseProperties,
                            ...commonProperties
                        ],
                        common: [
                            "_multiple",
                            "_default"
                        ],
                        senior: [
                            ...seniorProperties
                        ],
                        hide: [
                            ...hideProperties
                        ]
                    }
                },
                flatTable: {
                    name: "内部表格",
                    type: "flatTable",
                    description: "存储在此表单内部的列表",
                    icon: "bico-internaltable",
                    unitWidth,
                    canSearch: false,
                    canDefaultSearch: false,
                    canUpdate: true,
                    canBatchUpdate: false,
                    // canExport: false,
                    canBatchExport: false,
                    // canImport: false,
                    canBatchImport: false,
                    subLoop: false,
                    // operators: operatorMap["flatTable"],
                    // searchProps: {},
                    dataType: "object",
                    group: "relation",
                    formMap: {
                        self: [
                            ...baseProperties,
                            "_width"
                        ],
                        common: [
                            "_subForm",
                            "_flatTableIdentify",
                            "_isImportAndExport",
                            "_default"
                        ],
                        senior: [
                            ...seniorProperties
                        ],
                        hide: [
                            ...hideProperties,
                            "_span",
                            "_wrap",
                            "_br",
                            "_line",
                            "_clearable"
                        ]
                    }
                },
                cascaderTable: {
                    name: "级联表格",
                    type: "cascaderTable",
                    description: "存储在此表单内部的层级列表",
                    icon: "bico-Cascadetable",
                    unitWidth,
                    canSearch: false,
                    canDefaultSearch: false,
                    canUpdate: true,
                    canBatchUpdate: false,
                    // canExport: false,
                    canBatchExport: false,
                    // canImport: false,
                    canBatchImport: false,
                    subLoop: false,
                    // operators: operatorMap["text"],
                    // searchProps: {},
                    dataType: "object",
                    group: "relation",
                    formMap: {
                        self: [
                            ...baseProperties,
                            "_width"
                        ],
                        common: [
                            "_treeForm",
                            "_subForm",
                            "_default"
                        ],
                        senior: [
                            ...seniorProperties
                        ],
                        hide: [
                            ...hideProperties,
                            "_span",
                            "_wrap",
                            "_br",
                            "_line",
                            "_clearable"
                        ]
                    }
                }
            }
        },

        relation: {
            name: "关联字段",
            type: "relation",
            map: {
                reference: {
                    name: "关联数据",
                    type: "reference",
                    description: "关联内部表单的描述",
                    icon: "bico-linked-data",
                    unitWidth,
                    canSearch: true,
                    canDefaultSearch: false,
                    canUpdate: true,
                    canBatchUpdate: false,
                    // canExport: false,
                    canBatchExport: true,
                    // canImport: false,
                    canBatchImport: false,
                    subLoop: true,
                    operators: operatorMap["reference"],
                    operatorsSet: operatorMap["referenceSet"],
                    searchProps: {
                        _multiple: true,
                        _useCreate: false
                    },
                    searchPropsSet: {
                        _multiple: true,
                        canEdit: false
                    },
                    dataType: "object",
                    group: "relation",
                    formMap: {
                        self: [
                            ...baseProperties,
                            "_width",
                            "_clearable"
                        ],
                        common: [
                            "_ref, _screen, _refFields, _oto, _otoField",
                            "_exhibitionType",
                            "_useCreate",
                            "_required"
                        ],
                        senior: [
                            ...seniorProperties
                        ],
                        hide: [
                            ...hideProperties,
                            "_span",
                            "_wrap",
                            "_br",
                            "_line"
                        ]
                    }
                },
                referenceBy: {
                    name: "关联表格",
                    type: "referenceBy",
                    description: "关联内部列表的描述",
                    icon: "bico-relationaltable",
                    unitWidth,
                    canSearch: false,
                    canDefaultSearch: false,
                    canUpdate: true,
                    canBatchUpdate: false,
                    // canExport: false,
                    canBatchExport: false,
                    // canImport: false,
                    canBatchImport: false,
                    subLoop: false,
                    // operators: operatorMap["text"],
                    // searchProps: {},
                    dataType: "undefined",
                    group: "relation",
                    formMap: {
                        self: [
                            ...baseProperties,
                            "_width"
                        ],
                        common: [
                            "_ref, _screen, _refFields, _filterField, _sortField",
                            "_useCreate"
                        ],
                        senior: [
                            ...seniorProperties
                        ],
                        hide: [
                            ...hideProperties,
                            "_span",
                            "_wrap",
                            "_br",
                            "_line",
                            "_clearable"
                        ]
                    }
                }
            }
        },

        hide: {
            name: "隐藏字段",
            type: "hide",
            hide: true,
            map: {
                operation: {
                    name: "操作列",
                    type: "operation",
                    description: "操作列",
                    icon: "ios-remove",
                    align: "center",
                    unitWidth,
                    canSearch: false,
                    canDefaultSearch: false,
                    canUpdate: false,
                    canBatchUpdate: false,
                    // canExport: false,
                    canBatchExport: false,
                    // canImport: false,
                    canBatchImport: false,
                    subLoop: false,
                    // operators: operatorMap["text"],
                    // searchProps: {},
                    dataType: "undefined",
                    group: "hide",
                    formMap: {}
                },
                summary: {
                    name: "汇总",
                    type: "summary",
                    description: "级联表格节点的汇总",
                    icon: "ios-remove",
                    unitWidth,
                    canSearch: false,
                    canDefaultSearch: false,
                    canUpdate: false,
                    canBatchUpdate: false,
                    // canExport: false,
                    canBatchExport: false,
                    // canImport: false,
                    canBatchImport: false,
                    subLoop: false,
                    // operators: operatorMap["range"],
                    // searchProps: {
                    //     _type: "numberange"
                    // },
                    dataType: "number",
                    group: "hide",
                    formMap: {
                        self: [
                            ...baseProperties
                        ],
                        common: [
                            "_calField",
                            "_operator"
                        ],
                        senior: [
                            ...seniorProperties
                        ],
                        hide: [
                            ...hideProperties,
                            "_span",
                            "_wrap",
                            "_br",
                            "_line",
                            "_clearable"
                        ]
                    }
                }
            }
        }
    };
};



// WEBPACK FOOTER //
// ./src/data/mod/modFieldData.js